/**
 * Vercel Web Analytics — event filtering.
 *
 * `/app/*` URLs embed bid and document UUIDs. Those are customer data
 * and must not leave for a third-party analytics product, so every
 * in-app page view is cancelled before its beacon is sent. In-app
 * behaviour is PostHog's job (see `@/lib/posthog`).
 */

/** Path prefix for the authenticated app — never reported. */
const APP_PATH_PREFIX = '/app'

/** Origin used to resolve relative beacon URLs. */
const MARKETING_ORIGIN = 'https://www.bidcontext.ai'

/**
 * Drop any event whose URL points at the authenticated app.
 * Returning null cancels the beacon.
 */
export function beforeSend<T extends { url: string }>(event: T): T | null {
  try {
    const { pathname } = new URL(event.url, MARKETING_ORIGIN)
    if (pathname === APP_PATH_PREFIX || pathname.startsWith(`${APP_PATH_PREFIX}/`)) {
      return null
    }
  } catch {
    // Unparseable URL — fail closed rather than leak an unknown path.
    return null
  }
  return event
}
